document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-calculator-hub]').forEach((hub) => {
    const tabs = hub.querySelectorAll('[data-hub-tab]');
    const categories = hub.querySelectorAll('[data-hub-category]');
    const cards = hub.querySelectorAll('[data-hub-card]');
    const overlay = hub.querySelector('[data-hub-overlay]');
    const modalTitle = hub.querySelector('[data-hub-modal-title]');
    const closeBtn = hub.querySelector('[data-hub-modal-close]');
    const panels = hub.querySelectorAll('[data-calc-panel]');

    let activeFilter = 'all';

    function normalizeFilter(value) {
      const key = String(value || '')
        .replace(/^#/, '')
        .trim()
        .toLowerCase();

      if (key === 'pool' || key === 'mini' || key === 'rv' || key === 'all') return key;
      if (key === 'mini-split' || key === 'mini_split') return 'mini';
      return 'all';
    }

    function setHash(filter) {
      if (!window.history?.replaceState) return;
      const url = new URL(window.location.href);
      url.hash = filter && filter !== 'all' ? filter : '';
      window.history.replaceState(null, '', url.toString());
    }

    function setFilter(filter) {
      activeFilter = filter;
      hub.dataset.view = filter;

      tabs.forEach((tab) => {
        tab.classList.toggle('is-active', tab.dataset.hubTab === filter);
      });

      categories.forEach((cat) => {
        const key = cat.dataset.hubCategory;
        const show = filter === 'all' || key === filter;
        cat.classList.toggle('is-hidden', !show);
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const key = tab.dataset.hubTab;
        if (activeFilter === key) {
          setFilter('all');
          tabs.forEach((t) => t.classList.remove('is-active'));
          setHash('all');
          return;
        }
        setFilter(key);
        setHash(key);
      });
    });

    function openModal(calcType, title, miniTab) {
      if (!overlay || !modalTitle) return;

      modalTitle.textContent = title;

      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.calcPanel === calcType);
      });

      if (calcType === 'mini_split') {
        const miniWidget = hub.querySelector('[data-calc-panel="mini_split"] [data-mini-split-calculator]');
        if (miniWidget && miniTab) {
          miniWidget.dispatchEvent(
            new CustomEvent('mini-split-activate-tab', { detail: { tabId: miniTab }, bubbles: false })
          );
        }
      }

      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      panels.forEach((panel) => panel.classList.remove('is-active'));
    }

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        openModal(card.dataset.calculatorType, card.dataset.modalTitle, card.dataset.miniTab || '');
      });
    });

    closeBtn?.addEventListener('click', closeModal);

    overlay?.addEventListener('click', (e) => {
      if (e.target === overlay) closeModal();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay?.classList.contains('is-open')) closeModal();
    });

    function applyHash() {
      const filter = normalizeFilter(window.location.hash);
      setFilter(filter);
      if (filter === 'all') tabs.forEach((t) => t.classList.remove('is-active'));
    }

    window.addEventListener('hashchange', applyHash);
    applyHash();
  });
});
